import React, { useContext, useEffect, useState } from 'react';
import { LocalizeContext } from 'react-locale-language';
import { toast } from 'react-toastify';
import { makeApiRequests } from '../../helpers/api';
import { ENDPOINTS } from '../../helpers/constants';
import VideoPlayer from './VideoPlayer';
import CircularProgressBar from './circular-progress';
import { Button } from '../ui/button';
import { X } from 'lucide-react';

export default function ExplanatoryVideoLayout({ videoKey, autoplay, showPlayer, setShowPlayer }) {
  const [videoLink, setVideoLink] = useState();
  const [videoLoading, setVideoLoading] = useState(false);
  const { translate } = useContext(LocalizeContext);

  const getAppVideo = async () => {
    setVideoLoading(true);
    try {
      const { response, error } = await makeApiRequests({
        endpoint: ENDPOINTS.APP_VIDEOS_LIST,
        requestBody: {
          filter: { key: videoKey }
        }
      });
      setVideoLoading(false);

      if (error) {
        toast.error(error);
        return;
      }

      setVideoLink(response?.[0]?.url);
    } catch (e) {
      setVideoLoading(false);
      toast.error('Could not get video, please try again!');
      console.log(e);
    }
  };

  useEffect(() => {
    getAppVideo();
  }, [videoKey]);

  return (
    <div className="flex h-full items-center justify-center w-[80%] content-center bg-white rounded-lg shadow-md relative p-16">
      <Button
        variant="ghost"
        className="absolute top-0 right-0 m-2 rounded-full"
        onClick={() => setShowPlayer(false)}
        size="icon"
      >
        <X size={24} />
      </Button>
      <div className="flex justify-center items-center gap-2 w-full relative h-full ">
        {videoLoading && (
          <div className="p-5 text-center">
            <CircularProgressBar size={5} />
          </div>
        )}
        {!videoLoading &&
          (videoLink ? (
            <div className="rounded-2xl overflow-hidden w-full">
              <VideoPlayer videoLinks={[videoLink]} autoplay={autoplay} height={420} />
            </div>
          ) : (
            <div className="p-5 text-center">
              <h4 className="text-muted large">{translate('video_not_found_please_contact_admin')}</h4>
            </div>
          ))}
      </div>
    </div>
  );
}
